import { PaginationFilterRequest } from "./core.model";

export interface RunEventKey {
    id: number;
    name: string;
    isMajor: boolean;
}

export interface UpsertRunEventKey {
    id?: number;
    name?: string;
    isMajor?: boolean;
}

export class RunEventKeyPaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    onlyMajors?: boolean;
}


export interface CityRunEventKey {
    id: number;
    runEventKeyId: number;
    cityId: number;
}

export interface AssignCityRunEventKey {
    runEventKeyId: number;
    cityId: number;
}
